import { Button } from '@ps-design-system/components/Button';
import WarningIcon from '@ps-design-system/icons/Warning/Warning24';
import XIcon from '@ps-design-system/icons/X/X24';
import React from 'react';
import { connect } from 'react-redux';
import BootstrapModal from 'shared-components/modal/bootstrap-modal';
import { CATERING_PACKAGE_FORM } from '../../app-main/components/reduxForms/constants/formNames';
import { CateringOrderSummary } from './CateringOrderSummary';
import {
  calculateOrderTotal,
  getSelectedAddOns,
  getSelectedMenuItems
} from '../catering-utils';

export class CateringOrderSummaryModalCmp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nextBtnDisabled: true
    };

    this.handleNextClick = this.handleNextClick.bind(this);
  }

  handleNextClick = () => {
    const { onNext, formValues, booking, cateringPackage, profile } =
      this.props;
    const { selectedItems, addOns } = formValues || {};
    const selectedMenuItems = getSelectedMenuItems(
      selectedItems,
      cateringPackage,
      booking?.number_of_guests
    );

    const selectedAddOns = getSelectedAddOns(addOns, booking?.number_of_guests);

    const estimatedTotal = calculateOrderTotal(
      cateringPackage,
      selectedMenuItems,
      selectedAddOns,
      booking?.number_of_guests
    );

    analytics.track('catering_payment_btn_clicked', {
      booking_id: booking?._id,
      sso_id: profile?.data?.SSOid,
      activity_tag: booking?.tags?.activity,
      catering_package_id: cateringPackage?.id,
      order_total: parseFloat(estimatedTotal),
      add_ons: (selectedAddOns || []).map((addOn) => ({
        name: addOn.name,
        price: addOn.total
      }))
    });

    onNext();
  };

  render() {
    const {
      cateringPackage,
      closeModal,
      onBack,
      onNext,
      booking,
      formValues,
      errorMsg
    } = this.props;
    const { deliveryTime } = formValues || {};

    return (
      <BootstrapModal
        {...this.props}
        modalSize="lg-size"
        modalClass="catering-menu-form-modal catering-order-summary-modal"
        fixedHeaderFooter={true}
        header={
          <div className="relative">
            <h5 className="tw-headline-4 no-margin">Order summary</h5>
            <p className="tw-body-2 text-gray-600 no-margin">
              Not positive on all the details just yet? Don’t worry! You can
              book and finalize up to three days before your event.
            </p>
            <Button
              className="absolute"
              style={{ top: '0', right: '0' }}
              iconOnly={true}
              variant="text-only"
              onClick={closeModal}
            >
              <XIcon />
            </Button>
          </div>
        }
        body={
          <CateringOrderSummary
            cateringPackage={cateringPackage}
            booking={booking}
          />
        }
        footer={
          <div className="catering-footer-content-wrap">
            {errorMsg && (
              <div
                className="alert alert-danger catering-error-msg-wrap"
                role="alert"
              >
                <WarningIcon />
                <p className="tw-body-1 no-margin">{errorMsg}</p>
              </div>
            )}
            <Button
              onClick={onBack}
              variant="underline"
              className="back-btn-hidden-mobile"
            >
              Back
            </Button>
            <Button
              onClick={onBack}
              variant="outline-1"
              appearance="white"
              className="back-btn-hidden-desktop"
            >
              Back
            </Button>
            <Button onClick={this.handleNextClick} disabled={!deliveryTime}>
              Continue to payment
            </Button>
          </div>
        }
        addCloseIcon={false}
      />
    );
  }
}

const mapStateToProps = ({ form, profile }) => ({
  formValues: form[CATERING_PACKAGE_FORM]?.values,
  profile
});

export const CateringOrderSummaryModal = connect(mapStateToProps)(
  CateringOrderSummaryModalCmp
);
